import { type GetHookResponse } from '../hooks'
import { reportMapKey } from '../keys'
import { useTantalimQuery } from '../query'
import { type ReportMapInput, type ReportMapSuccess } from '@terros/common'
import { useState } from 'react'

export function useReportMap(input: ReportMapInput, enabled = true): GetHookResponse<ReportMapSuccess> {
  const [data, setData] = useState<ReportMapSuccess | undefined>(undefined)
  const state = useTantalimQuery<ReportMapInput, ReportMapSuccess, ReportMapSuccess>({
    url: '/report/map',
    queryKey: reportMapKey(input),
    input,
    convertResponse: (data) => {
      setData(data)
      return data
    },
    options: {
      enabled,
    },
  })
  return { ...state, data }
}
